/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_Knp_LookupInputs */



/**
* | output |
* | --- |
* | "Open KNP terminology lookup" |
*
* @param {Open_Knp_LookupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_knp_lookup = /** @type {((inputs?: Open_Knp_LookupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_Knp_LookupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir la recherche terminologique KNP")
	if (locale === "de") return /** @type {LocalizedString} */ ("KNP-Terminologie-Lookup öffnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri la ricerca terminologica KNP")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Откройте поиск терминов КНП")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir la búsqueda de terminología de KNP")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开 KNP 术语查询")
	if (locale === "ja") return /** @type {LocalizedString} */ ("KNP用語検索を開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओपन केएनपी शब्दावली खोज")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Consulta de terminologia KNP aberta")
	return /** @type {LocalizedString} */ ("Open KNP terminology lookup")
});